export enum PreviousPage {
    NISOO2ProgramRequestListPage = 1,
    ProgramRequestListPage = 2,
    ProgramRequestDetailPage = 3,
    DashboardPage = 4    
}